.card {
    border: 1px solid var(--static-divider-standard);
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: var(--static-background-strong);
    position: relative;
    flex: 1
  }
  
  .header {
    padding: 1rem;
    position: relative;
    cursor: pointer;
  }
  
  .backgroundContainer {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
  }


  
  .backgroundContainerRisingSvg {
    height: 100%;
    object-fit: cover;
    fill: var(--sentiment-background-positive);
  }

   .backgroundContainerLoweringSvg {
    height: 100%;
    object-fit: cover;
    fill: var(--sentiment-background-negative);
  }
  
  .content {
    position: relative;
    z-index: 10;
  }
  
  .labelContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 16px;
  }
  
  .label {
    color: var(--static-text-standard);
    font-size: var(--fs-x-small);
    font-weight: 400;
    line-height: 16px;
  }
  
  .arrow {
    transform: rotate(0deg);
    transition: transform 0.2s;
  }
  
  .arrowExpanded {
    transform: rotate(180deg);
  }
  
  .titleContainer {
    margin-top: 1rem;
  }
  
  .title {
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
    color: var(--static-text-strong);
  }
  
  .titleUnderline {
    height: 2px;
    background-color: #3b82f6;
    width: 3rem;
    margin-top: 0.25rem;
  }
  
  .percentageContainer {
    margin-top: 12px;
  }
  
  .percentageBadge {
    display: inline-flex;
    align-items: center;
    padding: 0rem 0.375rem;
    border-radius: 6px;
    gap: 0.25rem;
  }
  
  .rising {
    background-color: var(--sentiment-background-positive);
  }
  
  .falling {
    background-color: var(--sentiment-background-negative);
  }
  
  .percentageIcon {
    margin-right: 0.25rem;
  }

  .percentageIconFalling {
    fill: #CD0710
  }
  
  .rising .percentageIcon {
    color: var(--sentiment-text-positive);
  }
  
  .falling .percentageIcon {
    color: var(--sentiment-text-negative);
  }
  
  .rotateIcon {
    transform: rotate(180deg);
  }
  
  .percentageText {
    font-size: 16px;
    line-height: normal
  }
  
  .rising .percentageText {
    color: #16a34a;
  }
  
  .falling .percentageText {
    color: #dc2626;
  }
  
  .expandedSection {
    padding: 0.5rem 1rem;
    background-color: var(--static-background-strong);
    position: relative;
    z-index: 10;
  }
  
  .subFieldsGrid {
    
  }
  
  .subFieldItem {
    /* Default styling */
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  
  .subFieldFullWidth {
    /* grid-column: span 2; */
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  
  .subFieldLabel {
    color: #6b7280;
    font-size: 12px;
  }
  
  .subFieldValue {
    font-size: 14.48px;
    font-weight: 500;
    margin-top: 0.125rem;
  }